import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// IMPORTANT: Keep the initial language stable to avoid SSR/client text mismatches.
// Hydration failures here are commonly triggered by language detectors choosing `en-US`
// while you only ship `en` translation files.
export const i18nReady = new Promise<void>((resolve, reject) => {
  i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init(
      {
        debug: true,
        lng: 'en',
        fallbackLng: 'en',
        defaultNS: 'common',
        ns: ['common'],

        // Allow switching languages after hydration, but keep the initial SSR/client
        // language stable (this `lng: 'en'` prevents hydration mismatches).
        supportedLngs: ['en', 'pt', 'ru', 'tr'],
        backend: {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        interpolation: {
          escapeValue: false, // React already does escaping
        },
        react: {
          useSuspense: false,
        },
      },
      (err) => {
        if (err) {
          reject(err);
        } else {
          resolve();
        }
      },
    );
});
export default i18n;
